import React from 'react';
import PropTypes from 'prop-types';
import style from './style.module.scss';

export function Content(props) {
  const className = `${style.text} ${props.className}`;
  return <p className={className}>{props.text}</p>;
}

Content.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * Text to display as content
   */
  text: PropTypes.string,
};

Content.defaultProps = {
  className: '',
};
